import React from 'react';
import moment from 'moment';
import * as CONFIG from 'constants/config';
import { connect } from 'react-redux';
import { ShowIf } from 'components/utils';
import { DropDown, DatePicker, TextArea } from 'components/tt-forms/common';
import { DropDownChonStateXuLyDon, DropDownMulipleUse } from 'components/tt-forms';
import { LetterProcessingWorkFlow, DuLieuHeThong, Danhmuc } from 'api';
import { processType } from 'constants/process-type';
import { validatable } from 'components/utils';
import { msg } from "constants/message";
import { ContainerFileDinhKem } from 'components/upload';

const process = [processType.xuLyDon.processing.trinhLanhDao, processType.xuLyDon.processing.yeuCauGapLanhDao, processType.xuLyDon.processing.trinhTruongPhong];

class TrinhLanhDao extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      form_TrinhLanhDao: false,
      form_YeuCauGapLanhDao: false,

      donId: this.props.donId,

      numberState: 0,
      onlyState: '',
      nextState: '',

      hideDropdown: false,

      thoiHanXuLy: '',
      noiDung: '',
      lanhDaoChiDinh: '',
      dataShow: [],
      dataTruongPhong: []
    }
  }

  componentWillMount() {
    this.checkState();
    this.getDataTruongPhong();
  }

  getDataTruongPhong() {
    Danhmuc.actions.getThamSo.request(null, {tuKhoa: 'CQQL_BAN_TIEP_CONG_DAN'}).then(res => {
      if (res.data && res.data._embedded && res.data._embedded.thamSoes.length) {
        DuLieuHeThong.actions.getChuyenVienThuocPhongBan.request({ coQuanQuanLyId: res.data._embedded.thamSoes[0].giaTri, vaiTro: 'TRUONG_PHONG' }).then(res => {
          if(res.data._embedded) {
            this.setState({
              dataTruongPhong: res.data._embedded.congChucs
            })
          }
        })
      }
    });
  }

  getListDocument() {
    let dataShow = this.props.listTaiLieuVanThu.filter((item) => {
      return item.donId != this.state.donId
    });
    this.setState({
      dataShow: dataShow
    });
  }

  checkState() {

    let numberState = 0;
    let onlyState = '';
    process.map((item, i) => {

      if (this.props.getState(this.props.listNextStates, item)) {

        onlyState = item;
        numberState++;

        switch (item) {

          case processType.xuLyDon.processing.trinhLanhDao:
            this.setState({
              onlyState: onlyState,
              numberState: numberState,
              form_TrinhLanhDao: true
            });
            break;

          case processType.xuLyDon.processing.trinhTruongPhong:
            this.setState({
              onlyState: onlyState,
              numberState: numberState,
              form_TrinhLanhDao: true
            });
            break;

          case processType.xuLyDon.processing.yeuCauGapLanhDao:
            this.setState({
              onlyState: onlyState,
              numberState: numberState,
              form_YeuCauGapLanhDao: true
            });
            break;
        }
      }
    });
  }

  componentDidMount() {
    this.onlyOneState();
    if (this.state.donId) {
      this.getThongTinXuLy(this.state.donId);
    }
    this.getListDocument();
  }
  componentWillReceiveProps(np) {
    if (np.thongTinDon != this.props.thongTinDon && this.props.thongTinDon.loaiDonId != np.thongTinDon.loaiDonId) {
      this.getThoiHanXuLyMacDinh(np.thongTinDon.loaiDonId);
    }
  }
  onlyOneState() {
    if (this.state.numberState == 1) {
      let newState = {
        ...this.state,
        nextState: this.state.onlyState,
        hideDropdown: true,
      }

      this.setState({
        ...newState
      }, this.trigger(newState, true));
    }
  }

  getThoiHanXuLyMacDinh(loaiDon) {
    let params = {
      type: loaiDon
    }
    DuLieuHeThong.actions.getThoiHanXuLyMacDinh.request(null, params).then(res => {
      let thoiHanXuLyMacDinh = moment(res.data).format('DD/MM/YYYY');
      this.setState({
        thoiHanXuLy: thoiHanXuLyMacDinh
      })
    })
  }

  getThongTinXuLy(donId) {
    LetterProcessingWorkFlow.actions.getThongTinXuLy.request({ id: donId }).then(res => {
      if (res.data) {
        let info = res.data.thongTinXuLyInfo;
        let newState = {...this.state};
        newState.thoiHanXuLy = info.thoiHanXuLy ? moment(info.thoiHanXuLy).format('DD/MM/YYYY') : '';
        newState.lanhDaoChiDinh = info.canBoXuLyChiDinh ? info.canBoXuLyChiDinh.id : '';
        newState.noiDung = info.yKienXuLy;
        newState.nextState = info.nextState ? info.nextState.type : '';
        this.setState({
          ...newState
        }, () => {
          this.trigger(newState, true);
        });

      }
    })
  }

  handleChange(name, e) {
    let newState = {
      ...this.state,
      [name]: e.target.value
    }

    if (name == 'nextState') {


      newState = {
        ...newState,
        noiDung: ''
      }

      if (this.state.donId == 0) {
        newState = {
          ...newState,
          lanhDaoChiDinh: '',
          noiDung: ''
        }
      }
    }

    this.setState({
      ...newState
    }, this.trigger(newState, false));
  }

  handleChangeDate(name, e) {
    if (typeof e.format == 'function') {
      let newState = {
        ...this.state,
        [name]: e.format(CONFIG.DateFormat)
      }

      this.setState({
        ...newState
      }, this.trigger(newState, false));
    } else {

      let newState = {
        ...this.state,
        [name]: e
      }

      this.setState({
        ...newState
      }, this.trigger(newState, false));
    }
  }

  trigger(newState, isInit) {

    let params = {
      thoiHanXuLy: moment(newState.thoiHanXuLy, 'DD/MM/YYYY').add(7, 'hours').toISOString(),
      yKienXuLy: newState.noiDung
    }

    if (newState.nextState) {
      let stateId = this.props.getState(this.props.listNextStates, newState.nextState);
      params.nextState = {
        id: Number(stateId),
        type: newState.nextState
      };

      if (newState.form_TrinhLanhDao && newState.nextState == processType.xuLyDon.processing.trinhLanhDao) {
        params.notice =  msg.xldTrinhLanhDao;
        if (newState.lanhDaoChiDinh)
          params.canBoXuLyChiDinh = {
            id: Number(newState.lanhDaoChiDinh)
          }
      }
      if (newState.form_TrinhLanhDao && newState.nextState == processType.xuLyDon.processing.trinhTruongPhong) {
        params.notice =  msg.xldTrinhLanhDao;
        if (newState.lanhDaoChiDinh)
          params.canBoXuLyChiDinh = {
            id: Number(newState.lanhDaoChiDinh)
          }
      }
      if (newState.form_YeuCauGapLanhDao && newState.nextState == processType.xuLyDon.processing.yeuCauGapLanhDao) {
        params.notice =  msg.xldYeuCauGapLanhDao;
      }
    }

    this.props.onChange(params, isInit);
  }

  render() {
    return (
      <div className="items-form">
        <div className="row pl10 pr10">

          <ShowIf condition={!this.state.hideDropdown}>
            <DropDownChonStateXuLyDon require
              value={this.state.nextState}
              label="Hướng xử lý"
              onChange={this.handleChange.bind(this, 'nextState')}
              data={this.props.listNextStates}
              bindValidator={this}
              name="dropdownChonXuLy" />
          </ShowIf>

          <ShowIf condition={this.state.form_TrinhLanhDao &&
            (this.state.nextState == processType.xuLyDon.processing.trinhLanhDao || this.state.nextState == processType.xuLyDon.processing.trinhTruongPhong)}>

            <DatePicker require
              value={this.state.thoiHanXuLy}
              label='Hạn xử lý'
              name="thoiHanXuLy"
              startDate={moment(new Date()).subtract(1, "days")}
              onChange={this.handleChangeDate.bind(this, 'thoiHanXuLy')}
              isValid={this.props.validate}
              bindValidator={this}
              channel="formTaoDon" />
            <ShowIf condition={this.state.nextState == processType.xuLyDon.processing.trinhLanhDao}>
              <DropDown
                label="Lãnh đạo"
                options={this.props.lanhDaoList}
                keyName="congChucId"
                valueName="hoVaTen"
                bindValidator={this}
                require
                channel='formTaoDon'
                selectedValue={this.state.lanhDaoChiDinh}
                onChange={this.handleChange.bind(this, 'lanhDaoChiDinh')}
                placeholder
                name="dropdownChonLanhDao" />
            </ShowIf>
            <ShowIf condition={this.state.nextState == processType.xuLyDon.processing.trinhTruongPhong}>
              <DropDownMulipleUse
                label="Lãnh đạo"
                bindValidator={this}
                require
                channel='formTaoDon'
                selectedValue={this.state.lanhDaoChiDinh}
                onChange={this.handleChange.bind(this, 'lanhDaoChiDinh')}
                keyName="congChucId"
                valueName="hoVaTen"
                data={this.state.dataTruongPhong}
                name="dropdownChonCanBoXuLyTruongPhong" />
            </ShowIf>

          </ShowIf>
        </div>
        <div className="row pl10 pr10">
          <ShowIf condition={this.state.form_TrinhLanhDao || this.state.form_YeuCauGapLanhDao}>
            <TextArea
              label="Ý kiến xử lý"
              value={this.state.noiDung || ''}
              onChange={this.handleChange.bind(this, 'noiDung')}
              name="textareaYKien" />
          </ShowIf>
        </div>
        {
          this.state.dataShow.length ?
            <div className="container-filedinhkem">
              <ContainerFileDinhKem label="Danh sách văn bản xử lý" disableAttachFile={true} dataShow={this.state.dataShow} />
            </div>
          :''
        }
      </div>
    );
  }
}

TrinhLanhDao.defaultProps = {
  data: {},
  listNextStates: [],
  validate: false,
  onChange: function () {
    console.log('Need to assign onChange method');
  },
  getState: function () {
    console.log('Need to assign getState method');
  },
  thongTinDon: {}
}

function bindStateToProps(state) {
  return {
    lanhDaoList: state.duLieuHeThong.lanhDaoList,
    userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {},
  }
}

export default connect(bindStateToProps)(validatable(TrinhLanhDao));



// WEBPACK FOOTER //
// ./src/components/modules/handle-letters/xu-ly-don/form-xu-ly/chuyen-vien-nhap-lieu/TrinhLanhDao.jsx